import * as React from "react";
import Search, { ISearchProps } from "~/components/search/search";

interface ISearchViewProps {
    contextModel: ISearchProps;
}

class SearchView extends React.Component<ISearchViewProps> {
    public render() {
        return <Search {...this.props.contextModel} />;
    }
}

export default SearchView;
